/// <amd-module name="Widgets/BuildHistogramWidget/BuildHistogramWidgetWrapper" />
import * as React from "react";

import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as VssLocation from "VSS/Platform/Location";

import * as TfsWidgetContext from "Tfs/Widget/Context";

import * as WidgetTelemetry from "Dashboards/WidgetCommon/WidgetTelemetry";
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";

import { UnconfiguredMessage } from "Reporting/Visuals/VisualMessages/UnconfiguredMessage";
import { VisualTitle } from "Reporting/Visuals/VisualTitle";

import { DefinitionType } from "Build/Client/Contracts/Build";
import { BuildHistogramWidget, IBuildHistogramWidgetProps } from "Build/Dashboard/BuildHistogramWidget";

interface BuildHistogramWidgetSettings {
    fullBranchName: string;
    buildDefinition: BuildDefinitionReference;
    }

interface BuildDefinitionReference {
    id: number;
    name: string;
    uri: string;
    projectId: string;
    type: DefinitionType;
}

export interface BuildWidgetProps extends WidgetProps {
    buildChartDefinitionId: number;
}

/** Wrapper around the BuildHistogramWidget component to facilitate rendering on a new web platform dashboard. */
export class BuildHistogramWidgetWrapper extends VssComponent<BuildWidgetProps> {
    private projectId: string;

    constructor(props: BuildWidgetProps, context: IVssComponentContext) {
        super(props);
        this.projectId = TfsWidgetContext.getProject(context.pageContext).id;
    }

    public componentDidMount() {
        this.props.onWidgetLoaded();
        WidgetTelemetry.onWidgetLoaded(this.context.pageContext, this.props);
    }

    public render(): JSX.Element {
        const histogramProps = this.getHistogramProps();
 
        if (!histogramProps) {
            return <UnconfiguredMessage visualTitle={this.props.name} size={this.props.size} onClick={this.props.onConfigure} renderSmallImage />;
        }

        return (
            <div className={"build-histogram-wrapper"}>
                <FPSLink
                    className={"build-histogram-link"}
                    target={this.props.openLinksInNewTab ? "_blank" : undefined}
                    rel={"noopener noreferrer"}
                    href={this.getBuildUrl(histogramProps.definitionId)}
                >
                    <VisualTitle text={this.props.name} suppressDefaultPadding />
                    <BuildHistogramWidget {...histogramProps} />
                </FPSLink>
            </div>
        );
    }

    private getHistogramProps(): IBuildHistogramWidgetProps | undefined {
        if (this.props.settings) {
            const parsedSettings: BuildHistogramWidgetSettings = JSON.parse(this.props.settings);
            const definitionType = JSON.parse(this.props.settings).type  
            var type:number=0;
            if(definitionType == 1) { 
                type=1;
            }   

            return {
                definitionId:
                    parsedSettings && parsedSettings.buildDefinition
                        ? parsedSettings.buildDefinition.id
                        : this.props.buildChartDefinitionId
                        ? this.props.buildChartDefinitionId
                        : -1,
                projectId: this.projectId,
                itemsCount: 20,
                fullBranchName: parsedSettings ? parsedSettings.fullBranchName : "",  
                type: type                
            } as IBuildHistogramWidgetProps;
        } else {
            return undefined;
        }
    }

    private getBuildUrl(definitionId: number) {
        return VssLocation.routeUrl(this.context.pageContext, "ms.vss-build-web.pipelines-hub-route", {
            ["project"]: this.projectId,
            ["definitionId"]: definitionId.toString()
        });
    }
}

VssComponent.register("buildHistogramWidget", BuildHistogramWidgetWrapper);
